import type { AnySchemaObject, KeywordDefinition } from 'ajv';
import type { DataValidationCxt } from 'ajv/dist/types';
import { get } from 'lodash-es';

import { ROOT_SECTIONS_KEY, SPLIT_BY_SECTIONS_KEY } from '../constants';

export const ensureSectionLengthMatches: KeywordDefinition = {
  keyword: 'ui:component',
  type: 'array',
  validate: (schema: any, data: any, parentSchema?: AnySchemaObject, dataCxt?: DataValidationCxt) => {
    // Only apply this validation when the value is "ToggleableSectionRepeater"
    if (schema !== 'ToggleableSectionRepeater') {
      return true;
    }

    const { rootData } = dataCxt ?? ({} as any);

    const rootSections = get(rootData || {}, ROOT_SECTIONS_KEY, []);

    if (!rootSections.length) {
      // No sections defined — any ToggleableSectionRepeater field must have at most one entry
      return data.length <= 1;
    }

    const currentKey = dataCxt?.instancePath?.split('/').slice(1).join('.');

    // Only check for section length keys that are listed under the "split_by_sections" key
    if (!get(rootData || {}, SPLIT_BY_SECTIONS_KEY, []).includes(currentKey)) {
      // TaggableSectionRepeater keys that are not listed under the "split_by_sections"
      // should have at most one entry, otherwise it is not valid
      if (data.length > 1) {
        return false;
      }

      return true;
    }

    return rootSections.length === data.length;
  },
  error: {
    message: 'array length must match the length of the sections array or at most one entry of not split by section',
  },
};
